import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useSettings } from "@/lib/settings";

const Brand = () => (
  <Link to="/" className="inline-flex items-center gap-2.5" aria-label="Edilstudio Immobiliare" data-testid="footer-logo">
    <img src="/icon-mono.png" alt="" className="h-11 w-auto" />
    <img src="/wordmark-white.webp" alt="Edilstudio Immobiliare" className="h-[19px] w-auto" />
  </Link>
);

export const Footer = () => {
  const s = useSettings();
  return (
    <footer className="bg-[#14263D] text-[#B9BDC4]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Brand />
          <p className="text-sm mt-4 leading-relaxed text-[#8C9098]">
            Agenzia immobiliare, studio tecnico e amministrazioni condominiali a Scandicci e Firenze: compravendite e affitti, valutazioni immobiliari gratuite, pratiche catastali e gestione condominiale trasparente. Il tuo team di fiducia per la casa.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Servizi</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/amministrazioni-condominiali/" className="hover:text-white transition-colors">Amministrazioni Condominiali</Link></li>
            <li><Link to="/agenzia-immobiliare-scandicci/" className="hover:text-white transition-colors">Agenzia Immobiliare</Link></li>
            <li><Link to="/studio-tecnico/" className="hover:text-white transition-colors">Studio Tecnico</Link></li>
            <li><Link to="/immobili" className="hover:text-white transition-colors">In Vetrina</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Link utili</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/valuta-la-tua-casa" className="hover:text-white transition-colors">Valuta la tua casa</Link></li>
            <li><Link to="/preventivo-condominio" className="hover:text-white transition-colors">Preventivo condominio</Link></li>
            <li><Link to="/cambio-amministratore-condominio" className="hover:text-white transition-colors">Cambio amministratore</Link></li>
            <li><Link to="/amministratore-condominio-scandicci" className="hover:text-white transition-colors">Amministratore a Scandicci</Link></li>
            <li><Link to="/amministratore-condominio-firenze" className="hover:text-white transition-colors">Amministratore a Firenze</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
            <li><Link to="/contact/" className="hover:text-white transition-colors">Contatti</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contatti</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#2472C8]" /> {s.address}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#2472C8]" /> <a href={`tel:${s.phone}`} className="hover:text-white">{s.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#2472C8]" /> <a href={`mailto:${s.email}`} className="hover:text-white">{s.email}</a></li>
            <li className="flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5 text-[#2472C8]" /> Lun–Ven 9:00–13:00 / 15:00–19:00</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#7C818A]">
          <span>© {new Date().getFullYear()} {s.company_name}. Tutti i diritti riservati.</span>
          <div className="flex gap-4">
            <Link to="/privacy-policy" className="hover:text-white">Privacy &amp; Cookie</Link>
            <Link to="/login" className="hover:text-white">Area Riservata</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
